import { ColorBreadcrumb } from "../../types/BonusUi";
import { CardSubtitle } from "../../types/CoreComponents";

export const DefaultBreadcrumbSubTitle: CardSubtitle[] = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class.",
  },
];

export const DividerBreadcrumbSubTitle: CardSubtitle[] = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb-icon",
  },
  {
    text: " class.",
  },
];

export const WithIconBreadcrumbSubTitle: CardSubtitle[] = [
  {
    text: "You can set icons breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: "class.",
  },
];

export const VariationBreadcrumbSubTitle: CardSubtitle[] = [
  {
    text: "You can set variations breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: "class through any icons sets.",
  },
];

export const ColorBreadcrumbSubTitle: CardSubtitle[] = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class and set background colors like ",
    code: "[.bg-*].",
  },
];

export const ColoredBreadcrumbData: ColorBreadcrumb[] = [
  {
    id: 1,
    color: "primary",
    item: ["Home", "Bonus Ui", "Breadcrumb"],
  },
  {
    id: 2,
    color: "secondary",
    item: ["Home", "Icons", "Flag-icon"],
  },
  {
    id: 3,
    color: "success",
    item: ["Home", "Gallery", "Gallery-grid"],
  },
];
